import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';

export default class GrowthAdapter extends ApplicationAdapter {
  host = config.growthApiHost;
  namespace = 'a/growth/api/v1';
}
